import React from 'react';

import FanzoneRecommend from '../FanzoneRecommend/FanzoneRecommend';

import './PaymentFailed.css';


function PaymentFailed(props) {

  return (
    <div className="calendar-checkout-container">
      <h1 className="calendar-checkout-title">Thank you for your interest!</h1>
      <p className="calendar-checkout-text">
        Unfortunately something went wrong and your purchase failed. Please note that no money was taken from your account.
        You can <a href="/calendar-purchase">retry purchasing</a> or if you have any questions or comments you can <a href="/contact">contact us</a>.
      </p>
      <FanzoneRecommend anchorId={props.anchorId} failed={true} />
    </div>
  );
}

// PaymentFailed.propTypes = {
// };

export default PaymentFailed;
